<template>
  <v-menu offset-y left>
    <a slot="activator" class="download__botao-link">
      <i class="fas fa-download" aria-hidden="true"/>
      Baixar
    </a>
    <v-list class="lista-menu">
            <v-list-tile
                v-for="(item, index) in opcoesAtivas"
                :key="index"
                :value="item"
                @click="emitirEventoDownload(item.valor)">

              {{ item.label }}
            </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import {opcoesDownload} from '@/core/constants'

export default {
    name: 'BotaoDownloadComLabel',
    props: {
        documentoVirtualizadoId: {
            type: String,
            required: true
        },
        ocultarOpcaoAssinado:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            opcoesDownload
        }
    },
    computed:{
        opcoesAtivas(){
            if(this.ocultarOpcaoAssinado){
                return opcoesDownload.tiposDownload.filter(tipo => tipo.valor !== 'ASSINADO')
            }
            else{
                return opcoesDownload.tiposDownload
            }
        }
    },
    methods: {
        emitirEventoDownload(tipoDownload) {
            this.$emit('baixarDocumento', tipoDownload, this.documentoVirtualizadoId)
        }
    }
}
</script>

<style scoped lang="stylus">
  .download
    color #888
    &__botao-link
      background-color #fff
      color #888
      padding 5px 10px 5px 5px
      min-width 50px
      max-width 90px
      margin-right 10px
      border 0.1px solid #CACFD2

      i
        color #777 !important
        font-size 13px
        top 0

      &:hover, &:active, &:focus
        background-color #e4e4e4
        padding 3px 8px 3px 3px
        border 3px solid #CACFD2
        border-radius 4px

</style>